module.exports = __webpack_public_path__ + "img/verify-phone.ae417d09.jpg";